/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Ownership scope filter for the ticket list.
 */
export enum TicketScope {
    MINE = 'Mine',
    MY_ORG = 'MyOrg',
    ALL = 'All',
    CREATED_OR_ASSIGNED = 'CreatedOrAssigned',
}
